var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { ICoordinatorServiceType } from '../../../Services/CoordinatorService/ICoordinatorService';
import { injectable } from '../../../../Data/Decorators/Injectable';
import { inject } from '../../../../Data/Decorators/Inject';
import * as Clipboard from 'expo-clipboard';
let CopyToClipboardUseCase = class CopyToClipboardUseCase {
    constructor(coordinatorService) {
        this.coordinatorService = coordinatorService;
    }
    execute(text) {
        return Clipboard.setStringAsync(text)
            .then(isSuccessful => {
            if (!isSuccessful) {
                return Promise.reject(new Error(`Unsuccessful copy of "${text}"!`));
            }
            this.coordinatorService.showToast({ text: 'Successful copy!' });
            return text;
        })
            .catch(err => {
            this.coordinatorService.showToast({ text: err.message, type: 'error' });
            return text;
        });
    }
};
CopyToClipboardUseCase = __decorate([
    injectable(),
    __param(0, inject(ICoordinatorServiceType)),
    __metadata("design:paramtypes", [Object])
], CopyToClipboardUseCase);
export { CopyToClipboardUseCase };
